import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Delete = ({ color = '#838685', ...rest }: Props) => {
  return (
    <Svg
      width={28}
      height={29}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.16797 24.5391C7.5263 24.5391 6.977 24.3106 6.52005 23.8536C6.06311 23.3967 5.83464 22.8474 5.83464 22.2057V7.03906H4.66797V4.70573H10.5013V3.53906H17.5013V4.70573H23.3346V7.03906H22.168V22.2057C22.168 22.8474 21.9395 23.3967 21.4826 23.8536C21.0256 24.3106 20.4763 24.5391 19.8346 24.5391H8.16797ZM19.8346 7.03906H8.16797V22.2057H19.8346V7.03906ZM10.5013 19.8724H12.8346V9.3724H10.5013V19.8724ZM15.168 19.8724H17.5013V9.3724H15.168V19.8724Z"
        fill={color}
      />
    </Svg>
  )
}

export default Delete
